import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth, arrowWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_RED } from "../../config/constants";

const Connector12CRed12DRed = ({ state, workState }) => (
	<g id="Track-12D-red-connector" transform="translate(2101.000000, 381.000000)">
		<line
			x1="90" y1="40" x2="40" y2="58"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			strokeWidth={tracksWidth}
			strokeLinecap="round"/>
	</g>
);

export default Connector12CRed12DRed;